import { render, staticRenderFns } from "./Report.vue?vue&type=template&id=73f6488a"
import script from "./Report.vue?vue&type=script&lang=js"
export * from "./Report.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/websites/streamlined-business-solutions/sbs-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('73f6488a')) {
      api.createRecord('73f6488a', component.options)
    } else {
      api.reload('73f6488a', component.options)
    }
    module.hot.accept("./Report.vue?vue&type=template&id=73f6488a", function () {
      api.rerender('73f6488a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/admin/industry/Report.vue"
export default component.exports